import { lazy } from "react";

// Ressurssidene lastes først når ruten besøkes. Se kommentaren i
// root/CRM.tsx om hvorfor.
const CompanyList = lazy(() =>
  import("./CompanyList").then((m) => ({ default: m.CompanyList })),
);
const CompanyCreate = lazy(() =>
  import("./CompanyCreate").then((m) => ({ default: m.CompanyCreate })),
);
const CompanyShow = lazy(() =>
  import("./CompanyShow").then((m) => ({ default: m.CompanyShow })),
);
const CompanyEdit = lazy(() =>
  import("./CompanyEdit").then((m) => ({ default: m.CompanyEdit })),
);

export default {
  list: CompanyList,
  create: CompanyCreate,
  edit: CompanyEdit,
  show: CompanyShow,
};
